<template>
  <div class="py-3">
    <page-loading v-if="!item" />
    <page-title v-if="item" :title="pageTitle" />
    <div v-if="item" class="mt-3">
      <content-block-fields :item="item" v-on:submit="onSubmit" v-on:cancel="onCancel">
        <template v-slot:save>Save</template>
      </content-block-fields>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ContentBlockAdd",
  props: ['id'],
  data() {
    return {
      item: {
        concurrencyCheck: '',
        title: 'New Content Block',
        isPage: true,
        description: '',
        value: ''
      }
    };
  },
  computed: {
    pageTitle: function () {
      return 'Content: ' + this.item.title;
    }
  },
  methods: {
    load: function () {
    },
    onCancel(evt) {
      this.$router.push('/contentBlock');
    },
    onSubmit(evt) {
      let url = '/api/contentBlock';

      axios
        .post(url, this.item)
        .then(response => {
          console.log(response);

          // TODO: Check for 200?

          this.item = response.data;

          this.$parent.showToast('"' + this.item.title + '" was successfully created.', {
            title: 'Created',
            variant: 'success',
            autoHideDelay: 5000
          });

          this.$router.push('/contentBlock');
        })
        .catch(error => {
          console.log(error);

          let errorMessage = 'Unable to create "' + this.item.name + '". An unknown error occurred.';

          if (error.response.status == 400)
            errorMessage = 'Unable to create "' + this.item.name + '". The data you provided could not be validated.\r\n' + error.response.data.SubErrors.join('\r\n');
          else if (error.response.status == 403)
            errorMessage = 'Unable to create "' + this.item.name + '". You are not logged in or do not have access.';

          this.$parent.showToast(errorMessage, {
            title: 'Error Creating',
            variant: 'danger',
            autoHideDelay: 5000
          });
        });
    }    
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>